import React from 'react';
import SideNav from '../../../components/SideNav';
import UserMenu from '../../../components/UserMenu';
import AnnouncementBanner from '../../../components/announcements/AnnouncementBanner';

/**
 * App-shell layout for the Incomm VOID Report.
 *
 * Visually identical to MainLayout, but height-constrained. MainLayout's shell
 * is `min-h-screen`, so it grows with its content and the whole page scrolls —
 * which carries SideNav (it is `lg:static`, i.e. in flow) and the header off
 * screen. The header's `sticky top-0` cannot save it either, because the
 * `overflow-hidden` on MainLayout's inner column leaves sticky with no
 * scrollport to stick to.
 *
 * This uses `h-screen` + `overflow-hidden` on both the shell and the content
 * column, the same structure as SopLayout, so nothing outside `main` can ever
 * scroll. `main` is `overflow-hidden` rather than SopLayout's `overflow-y-auto`
 * because this tile scrolls only its table body, not the whole page body.
 *
 * MainLayout itself is deliberately untouched: it backs every other tile.
 */
const VoidReportLayout = ({ children }) => (
  <div className="flex flex-col lg:flex-row h-screen bg-slate-900 overflow-hidden">
    <SideNav />
    <div className="flex-1 w-full lg:w-auto flex flex-col h-screen overflow-hidden">
      <header className="bg-slate-800 border-slate-700 border-b flex-shrink-0">
        <div className="px-6 py-4 flex justify-between items-center">
          <h1 className="text-xl font-semibold text-slate-200 ml-12 lg:ml-0 min-w-0 truncate">
            KSP | Headquarters
          </h1>
          <AnnouncementBanner />
          <div className="flex-shrink-0">
            <UserMenu isDarkMode />
          </div>
        </div>
      </header>

      {/* min-h-0 lets this flex child shrink below its content; without it the
          column grows and the page scrolls again. */}
      <main className="p-4 lg:p-6 flex-1 min-h-0 overflow-hidden">
        {children}
      </main>
    </div>
  </div>
);

export default VoidReportLayout;
